import * as tslib_1 from "tslib";
import { Type } from 'class-transformer';
import { KeyValueResultDto } from '../../_models/key-value-result-dto';
import { UserNameDisplayResultDto } from '../../_models/user-name-display-result-dto';
import { AccAllowanceSubCategoryResultDto } from './acc-allowance-sub-category-result-dto';
import { AccProjectRawDto } from './acc-project-raw-dto';
import { AccUsersForAssignmentResultDto } from './acc-users-for-assignment-result-dto';
const ɵ0 = () => AccProjectRawDto, ɵ1 = () => AccUsersForAssignmentResultDto, ɵ2 = () => KeyValueResultDto, ɵ3 = () => KeyValueResultDto, ɵ4 = () => KeyValueResultDto, ɵ5 = () => AccAllowanceSubCategoryResultDto, ɵ6 = () => KeyValueResultDto, ɵ7 = () => KeyValueResultDto, ɵ8 = () => UserNameDisplayResultDto, ɵ9 = () => Date, ɵ10 = () => Date;
export class AccEditorResultDto {
}
tslib_1.__decorate([
    Type(ɵ0),
    tslib_1.__metadata("design:type", AccProjectRawDto)
], AccEditorResultDto.prototype, "projectData", void 0);
tslib_1.__decorate([
    Type(ɵ1),
    tslib_1.__metadata("design:type", Array)
], AccEditorResultDto.prototype, "usersForAssignment", void 0);
tslib_1.__decorate([
    Type(ɵ2),
    tslib_1.__metadata("design:type", Array)
], AccEditorResultDto.prototype, "statusResult", void 0);
tslib_1.__decorate([
    Type(ɵ3),
    tslib_1.__metadata("design:type", Array)
], AccEditorResultDto.prototype, "category", void 0);
tslib_1.__decorate([
    Type(ɵ4),
    tslib_1.__metadata("design:type", Array)
], AccEditorResultDto.prototype, "allowanceCategory", void 0);
tslib_1.__decorate([
    Type(ɵ5),
    tslib_1.__metadata("design:type", Array)
], AccEditorResultDto.prototype, "allowanceSubCategory", void 0);
tslib_1.__decorate([
    Type(ɵ6),
    tslib_1.__metadata("design:type", Array)
], AccEditorResultDto.prototype, "depositType", void 0);
tslib_1.__decorate([
    Type(ɵ7),
    tslib_1.__metadata("design:type", Array)
], AccEditorResultDto.prototype, "depositStatus", void 0);
tslib_1.__decorate([
    Type(ɵ8),
    tslib_1.__metadata("design:type", UserNameDisplayResultDto)
], AccEditorResultDto.prototype, "lastModifiedBy", void 0);
tslib_1.__decorate([
    Type(ɵ9),
    tslib_1.__metadata("design:type", Date)
], AccEditorResultDto.prototype, "lastModifiedDate", void 0);
tslib_1.__decorate([
    Type(ɵ10),
    tslib_1.__metadata("design:type", Date)
], AccEditorResultDto.prototype, "defaultDueDate", void 0);
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10 };
